import { formatDate } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { DataMap } from '@grapecity/wijmo.grid'

import { Grid, ListItem, QualityControlSoilResult, QualityControlSoilResultTest, RepositoryModal } from '../../../shared'
import { SoilResultComponent } from './soil-result.component'

@Component({
    templateUrl: './soil-result-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, WjGridModule],
})
export class SoilResultModalComponent extends RepositoryModal<QualityControlSoilResult> implements OnInit, OnDestroy {
    reportSourceOptions: ListItem<string>[] = [
        new ListItem('Test Report', 'Test Report'),
        new ListItem('Daily Report', 'Daily Report'),
    ]
    passFailOptions: ListItem<string>[] = [
        new ListItem('Pass', 'Pass'),
        new ListItem('Fail', 'Fail'),
    ]
    passFailMap!: DataMap
    testGrid: Grid<QualityControlSoilResultTest>

    constructor() {
        super()
        this.testGrid = new Grid<QualityControlSoilResultTest>(this.services).isReadOnly(false).wrapColumnHeaders()
    }

    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as SoilResultComponent
        this.passFailMap = new DataMap(this.passFailOptions, 'value', 'display')

        if (this.isAdding) {
            this.target.job = parentComponent.selectedJob()
            this.target.tests = []
        } else if (!this.target.tests) {
            this.target.tests = []
        }

        this.testGrid.items = this.target.tests.map(test => ({
            ...test,
            reportId: test.reportId || this.target.id,
            testDate: this.parseTestDate(test.testDate),
        }))
    }

    ngOnDestroy(): void {
        this.testGrid.destroy()
    }

    addTest() {
        const test = new QualityControlSoilResultTest()
        test.id = '00000000-0000-0000-0000-000000000000'
        test.reportId = this.target.id
        test.testDate = null
        test.sortOrder = this.testGrid.items.length
        this.testGrid.items.push(test)
        this.testGrid.refresh()
    }

    deleteTest() {
        const selected = this.testGrid.selectedItem
        if (!selected) {
            this.services.notification.warning('Select a test row to delete')
            return
        }
        const index = this.testGrid.items.indexOf(selected)
        if (index >= 0) {
            this.testGrid.items.splice(index, 1)
            this.testGrid.refresh()
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) {
            this.services.notification.warning('Job is required')
            return false
        }

        this.target.tests = this.testGrid.items.map((test, index) => ({
            ...test,
            reportId: test.reportId || this.target.id,
            sortOrder: index,
            testDate: this.formatTestDate(test.testDate),
        }))

        return true
    }

    private parseTestDate(value: string | Date | null | undefined): Date | null {
        if (!value) {
            return null
        }
        if (value instanceof Date) {
            return value
        }
        const parsed = new Date(value)
        return isNaN(parsed.getTime()) ? null : parsed
    }

    private formatTestDate(value: string | Date | null | undefined): string {
        if (!value) {
            return ''
        }
        if (value instanceof Date) {
            return formatDate(value, 'M/d/yyyy', 'en-US')
        }
        return value
    }
}
